// steps/StepChannelName.jsx
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SmsIcon from "@mui/icons-material/Sms";

export default function StepChannelName({
  channelName,
  nameError,
  onChange,
}) {
  return (
    <TextField
      label="Nome do canal"
      placeholder="Financeiro, Atendimento..."
      variant="outlined"
      value={channelName}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      sx={{ mt: 2 }}
      error={Boolean(nameError)}
      helperText={nameError}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SmsIcon sx={{ color: "#5e1bbb" }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
